import ModalTemplate from "../../ModalTemplate/ModalTemplate";
import { useModalStore } from "../../../../stores/modalStore";
import { type MouseEvent, useEffect } from "react";
import { useVersionsQuery } from "@/shared/services";
import { MascotFeedback } from "@/shared";
import { InfoContent, MascotWrapper, TextContent } from "./InfoModal.styles";

export const InfoModal = () => {
  const { closeModal } = useModalStore();
  const { data } = useVersionsQuery();

  useEffect(() => {
    // Guardo opciones previas y fuerzo disableBackdropClick mientras el modal esté montado
    const prevOptions = useModalStore.getState().options;
    useModalStore.setState({ options: { ...(prevOptions ?? {}), disableBackdropClick: true } });

    return () => {
      // Restauro opciones previas al desmontar
      useModalStore.setState({ options: prevOptions });
    };
  }, []);

  const handleModalClick = (e: MouseEvent) => {
    e.stopPropagation(); // Evita que el click dentro del modal cierre el modal
  };

  const frontendVersion = data?.data?.versions?.frontend || "desconocida";
  const backendVersion = data?.data?.versions?.backend || "desconocida";
  const aiVersion = data?.data?.versions?.ai || "desconocida";


  return (
    <div onClick={handleModalClick}>
      <ModalTemplate onClose={closeModal} showCloseButton>
        <InfoContent>
          <MascotWrapper>
            <MascotFeedback
              variant="hello"
              name="cloud"
              decorative
              size="md"
              dropShadow="glow"
            />
          </MascotWrapper>
          <TextContent>
            <p>
            Este sitio ofrece herramientas para la auditoría de identificación de pacientes, acceso seguro a historias clínicas y análisis de datos médicos. Basado en el estándar HL7 FHIR, garantiza interoperabilidad y cumplimiento de la normativa nacional vigente, protegiendo la información de los pacientes.
            </p>
            <p>
            La plataforma permite ejecutar auditorías médicas de manera ágil y confiable, y cuenta con un módulo de análisis de datos que facilita la toma de decisiones.
            </p>
            <p>
            Nuestro compromiso es optimizar la gestión de la información en salud, unificando los datos clínicos de emergencias en un único espacio que refuerce la seguridad y democratice el acceso a la información.
            </p>
            <p>
            <strong>Frontend:</strong> {frontendVersion} {" | "} <strong>Backend:</strong> {backendVersion} {" | "} <strong>IA:</strong> {aiVersion}
            </p>
          </TextContent>
        </InfoContent>
      </ModalTemplate>
    </div>
  );
};
